<template>
  <div class="dialog__container">
    <el-table :data="tableData" style="width: 100%" v-loading="tableLoading">
      <el-table-column show-overflow-tooltip prop="projectName" label="项目名称" width="100"></el-table-column>
      <el-table-column show-overflow-tooltip prop="creditCode" label="省市区街道" width="200">
        <template slot-scope="scope">
          {{ scope.row.provinceName }}
          {{ scope.row.cityName }}
          {{ scope.row.districtName }}
          {{ scope.row.address }}
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="propertyUnitName" label="使用单位" width="150"></el-table-column>
      <el-table-column show-overflow-tooltip prop="contactTelephone" label="联系电话" width="100"></el-table-column>
      <el-table-column show-overflow-tooltip prop="finishRate" label="完成比例(%)" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.finishRate >= 100" style="color: red;">{{scope.row.finishRate}}</span>
          <span v-if="scope.row.finishRate < 100">{{scope.row.finishRate}}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="acceptStatusName" label="状态" width="80"></el-table-column>
      <el-table-column show-overflow-tooltip prop="currentNode" label="电销阶段" width="100"></el-table-column>
      <el-table-column show-overflow-tooltip prop="annualInspectionDate" label="年检时间" width="180"></el-table-column>
      <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" width="180"></el-table-column>

      <el-table-column label="操作" width="84" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleDtxx(scope.row)">电梯信息</el-button>
          <el-button size="mini" type="text" @click="handleEdit(scope.row)">详情</el-button>
          <el-button size="mini" type="text" v-if="scope.row.acceptStatus == 10"
            @click="handleTransferOrder(scope.row)">转交</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagenation__container">
      <div class="for-fff-bg">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
          :page-sizes="[25, 50, 100, 150, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>

      <add-dialog v-if="showAdd" @cancel="showAdd = false" @confirm="confirm" :editData="detail"></add-dialog>
      <add-cause v-if="editCauseVisible" :detail="causeDetail" @cancel="editCauseVisible = false"
        @confirm="handleEditCauseConfirm"></add-cause>
      <detail-project v-if="detailProjectVisible" :projectId="projectId" @cancel="detailProjectVisible = false"
        @confirm="handleDetailProjectConfirm">
      </detail-project>

    </div>
  </div>
</template>

<script>
  import {
    deleteContractCollection
  } from "@/api/ContractReceivables";
  import {
    getProjectPageList
  } from "@/api/salesManagement/dxjh";
  import {
    mapState
  } from "vuex";
 import AddDialog from "./addDialog.vue";
  import AddCause from "./AddCause.vue";
  import DetailProject from "./DetailProoject";
;
  export default {

    data() {
      return {
        showAdd: false,
        tableData: [],
        detail: {},
        pageIndex: 1,
        pageSize: 50,
        total: 0,
        tableLoading: true,
        causeDetail: {},
        editCauseVisible: false,
        projectId: null,
        detailProjectVisible: false
      };
    },
    components: {
      AddDialog,
      AddCause,
      DetailProject
    },
    props: {
      editData: {
        required: true,
      },
      tabStatus: {
        required: true,
      }
    },
    created() {
      console.log(222)
      this.detail = {
        ...this.editData
      };
      this.getProjectPageListFun();

    },
    computed: {
      ...mapState("common/dictionary", ["zffsDicts"]),
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = val;
        this.getProjectPageListFun();
      },
      handleCurrentChange(val) {
        this.pageIndex = val;
        this.getProjectPageListFun();
      },
      async getProjectPageListFun() {
        this.tableLoading = true;
        const params = {
          planId: this.editData.id,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          tabStatus: this.tabStatus
        };
        const res = await getProjectPageList(params);
        if (res.code === 200) {
          this.tableData = [...res.data.list];
          this.total = res.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.tableLoading = false;
      },
      handleBeforeClose(done) {
        this.$emit("cancel");
        done();
      },
      handleCancel() {
        this.$emit("cancel");
      },
      async handleConfirm() {
        this.$emit("confirm");
      },
      handleDetailProjectConfirm() {
        this.editProjectVisible = false;
        this.getListData();
      },
      addPlan() {
        this.showAdd = true;
      },
      confirm() {
        this.showAdd = false;
        this.realList();
      },
      async handleDelete(row) {
        this.$confirm("确定删除?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(async () => {
            const res = await deleteContractCollection({
              idList: [row.id]
            });
            if (res.code === 200) {
              this.$message.success("删除成功");
              this.realList();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      handleEdit(row) {
        this.detail = {
          ...row
        };
        this.detail = {
          planId: this.editData.id,
          projectId: row.id
        };
        this.showAdd = true;
      },
      handleDtxx(row) {
        this.projectId = row.id
        this.detailProjectVisible = true;
      },
      receiptMethodFormatter(row) {
        let str = "";
        this.zffsDicts.some((item) => {
          if (item.dictionaryCode == row.receiptMethod) {
            str = item.dictionaryValue;
            return true;
          }
        });
        return str;
      },
      handleTransferOrder(row) {
        this.detail = {
          ...row
        };
        this.causeDetail = {
          planId: this.editData.id,
          projectId: row.id
        };
        this.editCauseVisible = true;
      },
      handleEditCauseConfirm() {
        this.editCauseVisible = false;
        this.getProjectPageListFun();
      },
      needInvoiceFormatter(row) {
        if (row.needInvoice == 0) {
          return "否";
        }
        if (row.needInvoice == 1) {
          return "是";
        }
        return "";
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/salesManagement/dxjh/components/DetailTableData.vue